import { histogramPlot, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { COLOR_RULE } from "../indicatorTypes";
import { valuesReader } from "../math/priceSources";
import { smaAt } from "../math/movingAverages";

/**
 * Volume (research §1.4), as TV Volume: the volume of each bar, up when
 * the bar closed at or above its open, and its SMA over Period (Volume MA).
 */
export default {
  id: "volume",
  name: "Volume",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 10),
  ],
  plots: [
    linePlot("volumeMa", "Volume MA", PALETTE.LIME),
    histogramPlot("volume", "Volume", COLOR_RULE.BAR),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    const readVolume = valuesReader(series.volume);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const volume = Number(bars[index].volume);

      series.volume[index] = Number.isFinite(volume) ? volume : NaN;
      series.volumeMa[index] = smaAt(readVolume, index, period);
    }
  },
};
